import React, { useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function LoginScreen({ onLogin }) {
  const [mode,     setMode]     = useState("login"); // login | forgot
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState(null);
  const [success,  setSuccess]  = useState(null);

  const handleLogin = async () => {
    if (!email || !password) return setError("Email and password required.");
    setLoading(true); setError(null);
    const { data, error: err } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (err) return setError(err.message);
    onLogin(data.session);
  };

  const handleForgot = async () => {
    if (!email) return setError("Enter your email address first.");
    setLoading(true); setError(null);
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (err) return setError(err.message);
    setSuccess("Password reset email sent — check your inbox.");
  };

  const inp = {
    width: "100%", padding: "11px 14px", borderRadius: 8,
    border: "1px solid rgba(0,0,0,0.12)", background: "#F8F8F8",
    fontSize: 13, color: "#111", outline: "none", boxSizing: "border-box",
    fontFamily: "'DM Sans', sans-serif",
  };

  const btn = (bg = "#CC1A1A") => ({
    width: "100%", padding: "12px", borderRadius: 8, border: "none",
    background: loading ? "#aaa" : bg, color: "#fff",
    fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
    fontFamily: "'DM Sans', sans-serif", marginTop: 8,
  });

  return (
    <div style={{
      minHeight: "100vh", background: "#F8F8F8",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&family=DM+Mono:wght@500&display=swap');`}</style>

      <div style={{ width: "100%", maxWidth: 420, padding: "0 20px" }}>

        {/* Logo / Brand */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 56, height: 56, background: "#CC1A1A", borderRadius: 14,
            marginBottom: 14, boxShadow: "0 4px 20px rgba(204,26,26,0.3)",
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="16 7 22 7 22 13" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div style={{ fontSize: 26, fontWeight: 900, color: "#111", letterSpacing: "-0.03em" }}>RevXcel</div>
          <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
            {mode === "login"  && "Sign in to your workspace"}
            {mode === "forgot" && "Reset your password"}
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: "#fff", borderRadius: 16, padding: "28px 28px",
          boxShadow: "0 2px 24px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)",
        }}>
          {success ? (
            <div style={{ textAlign: "center", padding: "10px 0" }}>
              <div style={{ fontSize: 32, marginBottom: 12 }}>✅</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#16A34A", marginBottom: 8 }}>You're all set</div>
              <div style={{ fontSize: 12, color: "#555", lineHeight: 1.6 }}>{success}</div>
              <button onClick={() => { setSuccess(null); setMode("login"); }}
                style={{ ...btn(), marginTop: 20 }}>Back to Sign In</button>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

              <div>
                <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 5 }}>EMAIL ADDRESS</label>
                <input style={inp} type="email" placeholder="you@company.com" value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && mode === "login" && handleLogin()} />
              </div>

              {mode !== "forgot" && (
                <div>
                  <label style={{ fontSize: 11, fontWeight: 700, color: "#555", display: "block", marginBottom: 5 }}>PASSWORD</label>
                  <input style={inp} type="password" placeholder="••••••••" value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && mode === "login" && handleLogin()} />
                </div>
              )}

              {error && (
                <div style={{ padding: "9px 12px", background: "rgba(220,38,38,0.06)", border: "1px solid rgba(220,38,38,0.15)", borderRadius: 7, fontSize: 12, color: "#DC2626" }}>
                  {error}
                </div>
              )}

              {mode === "login" && (
                <>
                  <button onClick={handleLogin} disabled={loading} style={btn()}>
                    {loading ? "Signing in…" : "Sign In"}
                  </button>
                  <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 4 }}>
                    <button onClick={() => { setMode("forgot"); setError(null); }}
                      style={{ background: "none", border: "none", fontSize: 12, color: "#888", cursor: "pointer", padding: 0 }}>
                      Forgot password?
                    </button>
                  </div>
                </>
              )}

              {mode === "forgot" && (
                <>
                  <button onClick={handleForgot} disabled={loading} style={btn()}>
                    {loading ? "Sending…" : "Send Reset Link"}
                  </button>
                  <button onClick={() => { setMode("login"); setError(null); }}
                    style={{ background: "none", border: "none", fontSize: 12, color: "#888", cursor: "pointer", marginTop: 4, width: "100%", textAlign: "center" }}>
                    ← Back to Sign In
                  </button>
                </>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", marginTop: 24, fontSize: 11, color: "#bbb" }}>
          © {new Date().getFullYear()} RevXcel · All rights reserved
        </div>
      </div>
    </div>
  );
}
